/**
 * SearchTabs 컴포넌트
 *
 * 허밍/가사 검색 탭 전환 버튼
 */

import { Mic, Search } from 'lucide-react'
import { useI18n } from '../i18n'

// =============================================================================
// 타입 정의
// =============================================================================

export type SearchTab = 'humming' | 'lyrics'

interface SearchTabsProps {
  /** 현재 선택된 탭 */
  activeTab: SearchTab
  /** 탭 변경 핸들러 */
  onTabChange: (tab: SearchTab) => void
}

// =============================================================================
// 메인 컴포넌트
// =============================================================================

export function SearchTabs({ activeTab, onTabChange }: SearchTabsProps) {
  const { t } = useI18n()

  return (
    <div className="flex border-b border-dark-500">
      {/* 가사 탭 (왼쪽 - 기본) */}
      <button
        onClick={() => onTabChange('lyrics')}
        className={`
          flex-1 flex items-center justify-center gap-2 py-4 px-2 font-medium text-sm sm:text-base
          transition-colors duration-200
          ${activeTab === 'lyrics'
            ? 'text-accent-500 border-b-2 border-accent-500 bg-accent-500/10'
            : 'text-text-muted hover:text-text-secondary hover:bg-dark-600'
          }
        `}
      >
        <Search className="w-5 h-5 flex-shrink-0" />
        <span className="truncate">{t('tabLyrics')}</span>
      </button>

      {/* 허밍 탭 (오른쪽) */}
      <button
        onClick={() => onTabChange('humming')}
        className={`
          flex-1 flex items-center justify-center gap-2 py-4 px-2 font-medium text-sm sm:text-base
          transition-colors duration-200
          ${activeTab === 'humming'
            ? 'text-accent-500 border-b-2 border-accent-500 bg-accent-500/10'
            : 'text-text-muted hover:text-text-secondary hover:bg-dark-600'
          }
        `}
      >
        <Mic className="w-5 h-5 flex-shrink-0" />
        <span className="truncate">{t('tabHumming')}</span>
      </button>
    </div>
  )
}
